/*   Copyright 2017 Agneta Network Applications, LLC.
 *
 *   Source file: theme/source/main/compatibility.js
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

/*global UAParser*/

(function() {
  var parser = new UAParser();
  var browser = parser.getBrowser();

  var minVersion;

  switch (browser.name) {
    case 'Chromium':
      minVersion = 21;
      break;
    case 'Chrome':
      minVersion = 21;
      break;
    case 'Firefox':
      minVersion = 28;
      break;
    case 'Opera':
      minVersion = 12;
      break;
    case 'IE':
      minVersion = 11;
      break;
    case 'Edge':
      minVersion = 12;
      break;
    case 'Safari':
      minVersion = 6;
      break;
    case 'Mobile Safari':
      minVersion = 6;
      break;
    case 'Android Browser':
      minVersion = 2;
      break;
  }

  window.isCompatible = function() {

    if (minVersion) {

      var browserVersion = browser.version.split('.');
      while (browserVersion.length > 2) {
        browserVersion.pop();
      }
      browserVersion = browserVersion.join('.');
      browserVersion = parseFloat(browserVersion);
      if (browserVersion < minVersion) {
        return false;
      }

    }

    return true;

  };

})();
